module.exports = __webpack_public_path__ + "media/images/service/a_5-085acd4bad1a6a960e95e22aecaee2a6.png";